import store from "../store";

export default function authMiddleware(to, from, next) {
  if (!store.getters['auth/loggedIn']) {
    try {
      return next('/login');
    } catch (e) {
      console.warn(e)
    }

  }
  return next();
}